import { makeAutoObservable, makeObservable } from "mobx";
import AuthService from "../service/AuthService";
import axios from "axios";
import { API_URL } from "../http";
import RoomService from "../service/RoomService";
import { runInAction } from "mobx";
import { v4 as uuidv4 } from 'uuid';
import ErrorComponent from "../components/UI/Error/ErrorComponent";

export default class Store {
    user = {};
    isAuth = false;
    isLoading = false;
    isAuthLoadGoogle = false;
    isLoadingComponent = true;
    load_elems = Infinity;
    choice_betRo = null;
    modal = null
    messages = {}
    dataLang = {};
    load_imgs = 0;
    state_socket = "close"
    load_text = false;
    state_bonus = false;
    socket = null;
    
    visible_right_panel = true;
    
    state_chat = false;
    time_auction = 86400;
    current_url = "";
    sound=true;
    constructor() {
        makeAutoObservable(this)
        if (localStorage.getItem("soundState")){
            if (localStorage.getItem("soundState") === "false"){
                this.sound=false;
            }
        }
        if (localStorage.getItem("rightBar")){
            if (localStorage.getItem("rightBar") === "false"){
                this.visible_right_panel=false;
            }
        }
        window.addEventListener("resize", () => {

            this.isPhone = document.documentElement.clientWidth <= 1000;


        })
        this.isPhone = document.documentElement.clientWidth <= 1000;

    }
    set_visible_right_panel(state) {
        this.visible_right_panel = state;
    }
    set_state_chat(state) {
        this.state_chat = state;
    }
    set_current_url(url) {
        this.current_url = url;
    }
    set_time_auction(time) {
        this.time_auction = time;
    }
    set_socket(socket) {

        this.socket = socket
        this.socket.addEventListener("open", () => {
            this.state_socket = "open"
        })
    }

    set_bonus(status) {
        this.state_bonus = status
    }
    get_bonus() {
        return this.set_bonus;
    }
    get_modal() {
        return this.modal
    }
    set_modal(modal) {
        this.modal = modal
    }
    set_load_imgs(count) {
        this.load_imgs = count
    }
    set_load_elems(elems) {

        this.load_elems = elems;
    }
    set_sound_state(state){
        localStorage.setItem("soundState",state)
        this.sound=state;
    }
    add_message(message, type,disappear=false) {
        this.messages[uuidv4()] = {message,type,disappear}
        console.log(this.messages)
        
        
    }
    delete_message(id) {
        delete this.messages[id];

    }
    setIsLoadingComponent(value) {
        this.isLoadingComponent = value;
    }
    async setDataLang(value) {
        runInAction(() => {
            this.dataLang = {
                ...this.dataLang,
                ...value
            };
            //console.log("set", this.dataLang, value);
        });
        //console.log(this)


    }
    setChoice_betRoulete(choice) {
        this.choice_betRo = choice
    }
    setAuth(bool) {
        this.isAuth = bool;
    }
    setLoadText(state) {
        this.load_text = state;
    }
    setUser(user) {
        this.user = user;
    }
    async login(email, password, token) {
        try {
            this.setIsLoading(true)
            const response = await AuthService.login(email, password, token)

            if (response.data.err) {
                return response.data
            }
            localStorage.setItem("token", response.data.accessToken);
            this.setAuth(true);
            this.setUser(response.data.user);
            return {}
        }
        catch (e) {
            console.log("Ошибка, попробуйте чуть позже")
        }
        finally {
            this.setIsLoading(false)
        }
    }
    async getInfRoom(name) {
        try {
            this.setIsLoading(true)
            const response = await RoomService.getInfRoom(name)
            return response.data
        }
        catch (e) {
            console.log("Ошибка, попробуйте чуть позже")
        }
        finally {
            this.setIsLoading(false);

        }
    }
    async getRoom_listCost(page, sort) {
        try {
            this.setIsLoading(true)
            const response = await RoomService.getRoom_listCost(page, sort)
            return response.data.filter(el => el.name !== "gold" || el.name !== "bonus")
        }
        catch (e) {
            console.log("Ошибка, попробуйте чуть позже")
        }
        finally {
            this.setIsLoading(false);

        }
    }
    async reg(email, login, password, token, promocode,tokenCaptcha) {
        try {
            this.setIsLoading(true)
            const response = await AuthService.reg(email, login, password, token, promocode,tokenCaptcha);
            if (response.data.err) {
                //console.log("data_reg",response.data)
                return response.data
            }

            localStorage.setItem("token", response.data.accessToken);
            this.setAuth(true);
            this.setUser(response.data.user);
            //console.log(response.data.modal)
            return { modal: response.data.modal }
        }
        catch (e) {
            console.log("Ошибка, попробуйте чуть позже")
        }
        finally {
            this.setIsLoading(false)
        }
    }
    setIsLoading(bool) {
        this.isLoading = bool;
    }
    async logout() {
        try {
            const response = await AuthService.logout();
            localStorage.removeItem("token");
            this.setAuth(false);
            this.setUser({})
        }
        catch (e) {
            console.log("Ошибка, попробуйте чуть позже")
        }

    }
    async checkAuth() {

        try {
            this.setIsLoading(true)
            const response = await axios.get(`${API_URL}/refresh`, { withCredentials: true })

            if (!response.data.err) {
                localStorage.setItem("token", response.data.accessToken);
                this.setAuth(true);
                if (response.data.modal) {

                    this.set_modal(response.data.modal)
                }


                // const fetchBalance = await axios.post("https://snake.money/partnerAPI/partnerStats",)

                this.setUser(response.data.user);

            }
            else{
                this.add_message(response.data.err,ErrorComponent,true)
            } 



        }
        catch (e) {
            console.log("Ошибка, попробуйте чуть позже")
            this.setAuth(false)
        }
        finally {
            this.setIsLoading(false)
        }
    }
    checkShow() {
        try {
            this.setIsLoading(true)
            return this.isAuth;
        }
        catch (e) {
            console.log("Ошибка, попробуйте чуть позже")
        }
        finally {
            this.setIsLoading(false);
        }

    }
    getSkin() {
        return this.user.skin
    }

}